import React from 'react'

function Fields({hundleSelection}) {
  return (
    <div className='fields'>
        <div className="card" onClick={()=>{
            hundleSelection("Mathématique")
        }}>
            <div className="icon">
                <img src="images/math.svg" alt="" />
            </div>
            <h3>Mathématique</h3>
        </div>
        <div className="card" onClick={()=>{
            hundleSelection("Technique")
        }}>
            <div className="icon">
                <img src="images/tech.svg" alt="" />
            </div>
            <h3>Technique</h3>
        </div>
        <div className="card" onClick={()=>{
            hundleSelection("Sciences")
        }}>
            <div className="icon">
                <img src="images/sciences.svg" alt="" />
            </div>
            <h3>Sciences</h3>
        </div>
        <div className="card" onClick={()=>{
            hundleSelection("Informatique")
        }}>
            <div className="icon">
                <img src="images/info.svg" alt="" />
            </div>
            <h3>Informatique</h3>
        </div>
        <div className="card" onClick={()=>{
            hundleSelection("Lettres")
        }}>
            <div className="icon">
                <img src="images/lettres.svg" alt="" />
            </div>
            <h3>Lettres</h3>
        </div>
        <div className="card" onClick={()=>{
            hundleSelection("éco & gestion")
        }}>
            <div className="icon">
                <img src="images/eco.svg" alt="" />
            </div>
            <h3>éco & gestion</h3>
        </div>
    </div>
  )
}

export default Fields